<template>
  <v-dialog
    id="user-list-success-dialog"
    v-model="successDialogDisplayed"
    max-width="640"
    persistent
  >
    <v-card>
      <v-card-title class="headline">{{ successDialogTitle }}</v-card-title>
      <v-card-text>
        <v-alert
          id="user-list-success-dialog--success-alert"
          type="success"
          dense
          outlined
          class="mb-5"
        >
          <span v-html="successDialogBody"></span>
        </v-alert>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          id="user-list-success-dialog--closure-button"
          color="primary"
          @click="successDialogDisplayed = false"
        >
          Close
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import systemEvent from "../lib/const/systemEvent";

export default {
  data() {
    return {
      successDialogDisplayed: false,
      successDialogTitle: "",
      successDialogBody: "",
    };
  },

  async mounted() {
    this.$app.eventBus.$on(systemEvent.USER_LIST_SUCCESS_DIALOG_CALLED, async (argHash) => {
      this.successDialogTitle = argHash.successDialogTitle;
      this.successDialogBody = argHash.successDialogBody;
      this.successDialogDisplayed = argHash.successDialogDisplayed;
    });
  },

  beforeDestroy() {
    this.$app.eventBus.$off(systemEvent.USER_LIST_SUCCESS_DIALOG_CALLED);
  },
};
</script>
